import type { TrackingIntegration } from '@chukua/common';
import { useEffect, useState } from 'react';
import { getIntegration } from '../integrations.api';

export type SavedIntegrationState = { status: 'loading' } | { status: 'loaded'; integration: TrackingIntegration } | { status: 'error' };

/** The installation an edit sheet opens on; with no id (an install) there is nothing to load. */
export function useSavedIntegration(integrationId: string | undefined): SavedIntegrationState {
  const [saved, setSaved] = useState<SavedIntegrationState>({ status: 'loading' });

  useEffect(() => {
    if (!integrationId) return;
    let cancelled = false;
    getIntegration(integrationId)
      .then((integration) => !cancelled && setSaved({ status: 'loaded', integration }))
      .catch(() => !cancelled && setSaved({ status: 'error' }));
    return () => {
      cancelled = true;
    };
  }, [integrationId]);

  return saved;
}
